package com.havn.app.core.platform

import kotlinx.browser.window

actual fun havnCurrentWebHost(): String? =
    window.location.host.takeIf { it.isNotBlank() }

